import { useState, useMemo } from 'react';
import { useGetTeamCompetitionsQuery, useGetMemberSummaryQuery, useGetLatestRyderCupTeamsQuery } from '../state/api';
import { selectAllTeamCompetitions, selectAllMembers } from '../state/entitySelectors';
import { useAppSelector } from '../hooks/reduxHooks';
import CaptaincyStats from './captaincy-stats.tsx';
import { calculateCaptaincyStatistics } from './captaincy.utils';
import { filterAndSortCaptaincyRecords, type CaptaincyViewMode } from './captaincy-filters.utils';

const CaptaincyStatsContainer = () => {
  // State management for view mode
  const [viewMode, setViewMode] = useState<CaptaincyViewMode>('record');

  // Fetch data with RTK Query - include competitors to calculate appearances
  useGetTeamCompetitionsQuery({ withCompetitors: true });
  useGetMemberSummaryQuery();
  const { data: ryderCupTeams = [] } = useGetLatestRyderCupTeamsQuery();

  // Use entity selectors for optimized access to normalized data
  const teamCompetitions = useAppSelector((state) => selectAllTeamCompetitions(state, true));
  const members = useAppSelector(selectAllMembers);

  // Calculate captaincy statistics using extracted utility function
  const captaincyRecords = useMemo(
    () => calculateCaptaincyStatistics(teamCompetitions, members, ryderCupTeams),
    [teamCompetitions, members, ryderCupTeams]
  );

  // Filter and sort records based on view mode
  const displayRecords = useMemo(
    () => filterAndSortCaptaincyRecords(captaincyRecords, viewMode, ryderCupTeams.length > 0),
    [captaincyRecords, viewMode, ryderCupTeams]
  );

  return <CaptaincyStats records={displayRecords} viewMode={viewMode} onViewModeChange={setViewMode} />;
};

export default CaptaincyStatsContainer;
